import { GENERAL_SETTINGS_STORAGE_KEY, defaultTimeFormat, detectDefaultLocale } from '@/lib/locales';
// The key itself lives in lib/locales so lib code (i18n boot, the API client)
// can read the stored locale without importing from components/.
export { GENERAL_SETTINGS_STORAGE_KEY };
export const TIMEZONES = [
    'America/New_York',
    'America/Chicago',
    'America/Denver',
    'America/Los_Angeles',
    'America/Anchorage',
    'Pacific/Honolulu',
    'America/Phoenix',
    'America/Toronto',
    'America/Vancouver',
    'Europe/London',
    'Europe/Berlin',
    'Europe/Paris',
    'Europe/Zurich',
    'Europe/Vienna',
    'Europe/Madrid',
    'Australia/Sydney',
    'Australia/Melbourne',
    'Australia/Brisbane',
    'Australia/Hobart',
    'Australia/Adelaide',
    'Australia/Darwin',
    'Australia/Perth',
    'Australia/Broken_Hill',
    'Australia/Lindeman',
    'Australia/Eucla',
    'Australia/Lord_Howe',
    'Asia/Tokyo',
    'Asia/Singapore',
    'UTC',
];
// A user who never chose gets the browser's locale and that locale's clock
// convention, the same way the timezone is derived from the browser.
const detectedLocale = detectDefaultLocale();
export const GENERAL_SETTINGS_DEFAULTS = {
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    timeFormat: defaultTimeFormat(detectedLocale),
    locale: detectedLocale,
    sidebarClinicDisplayName: '',
};
export function loadGeneralSettings() {
    try {
        const raw = localStorage.getItem(GENERAL_SETTINGS_STORAGE_KEY);
        if (raw)
            return { ...GENERAL_SETTINGS_DEFAULTS, ...JSON.parse(raw) };
    }
    catch {
        /* ignore */
    }
    return { ...GENERAL_SETTINGS_DEFAULTS };
}
export function saveGeneralSettings(config) {
    localStorage.setItem(GENERAL_SETTINGS_STORAGE_KEY, JSON.stringify(config));
}
/** Display name override for the Studies sidebar; empty string = use API clinic name */
export function getSidebarClinicDisplayName() {
    try {
        const raw = localStorage.getItem(GENERAL_SETTINGS_STORAGE_KEY);
        if (!raw)
            return '';
        const parsed = JSON.parse(raw);
        return typeof parsed.sidebarClinicDisplayName === 'string'
            ? parsed.sidebarClinicDisplayName
            : '';
    }
    catch {
        return '';
    }
}
